'use strict';

var ResourceFactory = require('../Factory');
var Validate = require('../../core').Validate;

var definition = {
  name: 'Overlay',
  basePath: ':basePath',
  endpoint: 'overlays',
  debug: false,
  relations: {
    belongsTo: {
      Site: {
        localField: 'site',
        localKey: 'siteId'
      }
    }
  },
  methods: null
};

function OverlayResource (DS) {
  var resourceFactory = new ResourceFactory(DS);

  this.initialize = function (options) {
    var resourceOptions = getResourceOptions(options);
    return resourceFactory.createResource(resourceOptions);
  };
}

function getResourceOptions (options) {

  Validate.exists(options, 'fbBaseUri');
  Validate.exists(options, 'fbAuthToken');

  return {
    // name should be unique across all resources
    name: 'Overlay',
    apiBaseUri: options.apiBaseUri,
    modelMethods : {},
    collectionMethods: {},

    // definition to be formatted and passed to js-data DS
    definition: {
      format: definition,
      params: {
        basePath: options.apiBaseUri
      }
    },

    syncTriggers: {
      // collection: [{
      //   type: 'firebase',
      //   basePath: options.fbBaseUri,
      //   endpoint: 'overlays/sites/{{siteId}}/lastUpdated',
      //   token: options.fbAuthToken
      // }],
      // model: [{
      //   type: 'firebase',
      //   basePath: options.fbBaseUri,
      //   endpoint: 'overlays/items/:modelId/lastUpdated',
      //   token: options.fbAuthToken
      // }]
    }
  };
}
module.exports = OverlayResource;




// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/overlay/OverlayResource.js